import { Component, ReactNode } from "react"
import posthog from "posthog-js"
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import StateConstants from "src/states/StateContstants"
import ApiHandler from "src/api/ApiHandler"
import "./Premium.css"


interface PremiumGateProps {
    stateHandler: EventAdaptingStateHandler
    apiHandler: ApiHandler
    children: ReactNode
    lockedMessage?: string
    showTeaser?: boolean
}

interface PremiumGateState {
    isPremium: boolean
    isLoggedIn: boolean
}


class PremiumGate extends Component<PremiumGateProps, PremiumGateState> {
    constructor(props: PremiumGateProps) {
        super(props)
        this.state = {
            isPremium: props.stateHandler.get(StateConstants.IS_PREMIUM) || false,
            isLoggedIn: props.stateHandler.get(StateConstants.IS_LOGGED_IN) || false
        }

        props.stateHandler.addListener(StateConstants.IS_PREMIUM, (isPremium: boolean) => {
            this.setState({ isPremium })
        })
        props.stateHandler.addListener(StateConstants.IS_LOGGED_IN, (isLoggedIn: boolean) => {
            this.setState({ isLoggedIn })
        })
    }

    handleUpgrade() {
        posthog?.capture("plans_opened", { source: "premium_gate" })
        this.props.stateHandler.set(StateConstants.SHOW_PLAN_MODAL, true)
    }

    render() {
        if (this.state.isPremium) {
            return <>{this.props.children}</>
        }

        const message = this.props.lockedMessage || "Unlock with Premium"

        return (
            <div className="premium-gate">
                {this.props.showTeaser && (
                    <div className="premium-gate-teaser">
                        {this.props.children}
                    </div>
                )}
                <div className="premium-gate-card">
                    <p className="premium-gate-message">{message}</p>
                    <button
                        className="premium-gate-cta"
                        onClick={() => this.handleUpgrade()}
                    >
                        Unlock
                    </button>
                </div>
            </div>
        )
    }
}

export default PremiumGate
